import { ComponentProps, KeyboardEvent } from 'react'

import { type History } from '../../model/search-history-store/history'
import { Popup } from '../popup/popup'
import { RecentRoomList } from '../recent-room-list'
import { SearchHistoryList } from '../search-history-list/location'

type Props = ComponentProps<typeof Popup> & {
  onItemClick: (history: History) => void
  onClose: () => void
}

export const SearchHistoryPopup = ({
  onItemClick,
  onClose,
  ...restProps
}: Props) => {
  const handleOpenAutoFocus = (event: Event) => {
    event.preventDefault()
  }

  const handleKeyDown = (event: KeyboardEvent) => {
    event.preventDefault()

    switch (event.key) {
      case 'Escape': {
        onClose()
        break
      }
    }
  }

  return (
    <Popup
      className="flex h-[564px] w-[800px] overflow-hidden rounded-xl"
      onOpenAutoFocus={handleOpenAutoFocus}
      onKeyDown={handleKeyDown}
      autoFocus={true}
      {...restProps}
    >
      <SearchHistoryList onItemClick={onItemClick} />
      <RecentRoomList />
    </Popup>
  )
}
